var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6755 3.8328L18.1673 6.32344M17.2779 1.63863L10.5401 8.37643C10.1919 8.72408 9.95452 9.16702 9.85772 9.6494L9.23535 12.7648L12.3507 12.1412C12.8331 12.0447 13.2754 11.8083 13.6237 11.46L20.3615 4.72223C20.564 4.51976 20.7246 4.27939 20.8341 4.01485C20.9437 3.75031 21.0001 3.46677 21.0001 3.18043C21.0001 2.89409 20.9437 2.61056 20.8341 2.34602C20.7246 2.08147 20.564 1.84111 20.3615 1.63863C20.159 1.43616 19.9186 1.27555 19.6541 1.16598C19.3896 1.0564 19.106 1 18.8197 1C18.5333 1 18.2498 1.0564 17.9853 1.16598C17.7207 1.27555 17.4804 1.43616 17.2779 1.63863V1.63863Z",
    stroke: "#2B2D4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6475 15.1178V18.6472C18.6475 19.2713 18.3995 19.8698 17.9583 20.3111C17.517 20.7523 16.9185 21.0002 16.2945 21.0002H3.35299C2.72894 21.0002 2.13045 20.7523 1.68918 20.3111C1.2479 19.8698 1 19.2713 1 18.6472V5.70578C1 5.08172 1.2479 4.48323 1.68918 4.04196C2.13045 3.60069 2.72894 3.35278 3.35299 3.35278H6.88248",
    stroke: "#2B2D4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorder);
export default __webpack_public_path__ + "static/media/editorder.a5e47f41fb31b283043c17e385e9bfea.svg";
export { ForwardRef as ReactComponent };